export enum StagingAccount {
  StudioApp = 'studio-app',
  Studio2 = 'studio2'
}

/**
 * `ModuleName` enum values are all lower-case.
 */
export enum ModuleName {
  Cocaine = 'cocaine',
  Xanax = 'xanax',
  Mdma = 'mdma',
  Response = 'response',
  Lightning = 'lightning'
}

export enum ModuleNamePerceptionBar {
  Cocaine = 'Cocaine',
  Xanax = 'Xanax',
  Mdma = 'MDMA',
  Response = 'Fentanyl',
  Lightning = 'Lightning Round'
}

export enum ModuleNameScreenReader {
  Cocaine = 'Cocaine',
  Xanax = 'Xanax',
  Mdma = 'M D M A',
  Response = 'Overdose Response',
  Lightning = 'Lightning Round'
}

export enum StatusValue {
  INPROGRESS = 'in progress',
  COMPLETED = 'completed',
  PENDING = 'pending',
}

export enum MetadataType {
  QuestionVideoTimestamp = 'video_question_timestamp',
  QuestionMcqPart = 'question_mcq_part',
  QuestionVideoTimestampEad = 'video_question_timestamp_ead'
}

export enum QuestionType {
  Video = 'video',
  Mcq = 'mcq'
}

export enum SurveyQuestionType {
  Text = 'text',
  SingleSelect = 'single_select',
  MultiSelect = 'multi_select',
  Likert = 'likert'
}

export enum HTTP_STATUS {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500
}

export enum BgmTrack {
  None = '',

  Dashboard = 'dashboard',
  Completed = 'completed',

  Cocaine = 'cocaine',
  Xanax = 'xanax',
  Mdma = 'mdma',
  Response = 'response',
  Lightning = 'lightning'
}

export enum SfxTrack {
  LevelEnter = 'Level Enter 2',
  QuestionAppear = 'Question Pop Up 1',
  QuestionCorrect = 'Question Pop Up 2',
  QuestionIncorrect = 'Question Pop Up 3'
}

export enum BgmExtension {
  None = '',

  Dashboard = '.mp3',
  Completed = '.mp3',

  Cocaine = '.mp3',
  Xanax = '.mp3',
  Mdma = '.mp3',
  Response = '.mp3',
  Lightning = '.mp3'
}

export enum PreferenceType {
  A11yUseEad = 'a11y_use_ead',
  A11yUseAccessibleMcqGame = 'a11y_use_accessible_mcq',
  A11yBackgroundMusic = 'a11y_background_music',
  A11yClosedCaptions = 'a11y_closed_captions',
  A11yReduceMotion = 'a11y_reduce_motion',

  // ASM (Accessibility Support Modes)
  AsmVision = 'asm_vision',
  AsmHearing = 'asm_hearing',
  AsmMotor = 'asm_motor',
  AsmCognitive = 'asm_cognitive'
}
